import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/')({});